// eslint-disable-next-line import-x/order
import './services/datadog';

import React, { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import {
  QueryCache,
  QueryClient,
  QueryClientProvider,
} from '@tanstack/react-query';
import { toast } from 'react-toastify';

import App from './App';

import './styles/index.scss';

const queryCache = new QueryCache({
  onError: (error) => {
    if (error instanceof Error && error.name === 'AbortError') {
      return;
    }
    toast.error(
      error instanceof Error ? error.message : 'An unexpected error occurred',
      { autoClose: false }
    );
  },
});

const queryClient = new QueryClient({
  queryCache,
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false,
    },
  },
});

const root = createRoot(document.getElementById('root')!);
root.render(
  <StrictMode>
    <QueryClientProvider client={queryClient}>
      <App />
    </QueryClientProvider>
  </StrictMode>
);
